import { Module } from "vuex";
const user = JSON.parse(localStorage.getItem("user"));
const initialState = user ? { status: { loggedIn: true, expiDate: null }, user } : { status: { loggedIn: false }, user: null };

export const auth: Module<any, any> = {
  state: initialState,
  // getters: {
  //     querySearch: (state) => state.query,
  //     currentPageReceipt: (state) => state.query,
  // },
  mutations: {
    setloginSuccess(state, data) {
      state.status.loggedIn = true;
      // state.status.expiDate = (new Date()).setSeconds((new Date()).getSeconds() + 5);
      state.user = user;
    },
  },
  actions: {
    setloginSuccess(data) {
      console.log(data);
      data.commit("setloginSuccess");
    },
  },
};
